import { z } from 'zod';
import { clanSchema } from '~/util/types/clans';

export const leaderboardParamsSchema = z.object({
    search: z.string().max(100).default('').catch(''),
    sort: z
        .enum(['TotalPoints', 'RawPoints', 'ExtremeCount', 'Hardest'])
        .default('TotalPoints')
        .catch('TotalPoints'),
    type: z
        .enum(['users', 'countries', 'clans'])
        .default('users')
        .catch('users'),
    page: z.number().min(1).default(1).catch(1),
    country: z.number().min(0).default(0).catch(0),
    clan: clanSchema.nullable().default(null).catch(null),
});

export const defaultLeaderboardParams = leaderboardParamsSchema.parse({});

export type leaderboardParamsType = z.infer<typeof leaderboardParamsSchema>;
